import { render, staticRenderFns } from "./multiUserNotificationForm.vue?vue&type=template&id=e2fbf468&scoped=true"
import script from "./multiUserNotificationForm.vue?vue&type=script&lang=js"
export * from "./multiUserNotificationForm.vue?vue&type=script&lang=js"
import style0 from "./multiUserNotificationForm.vue?vue&type=style&index=0&id=e2fbf468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fbf468",
  null
  
)

export default component.exports